<template>
  <div class="ff-regular fb fb-col fb-main-between h-fullVh">
    <div class="item-flex-1">
      <div class="p-0-16 bg-FFFFFF mt-12">
        <div class="fb fb-main-between fb-cross-center h-56 bb">
          <label for="" class="font-34 c-171A1D">类型</label>
          <div class="border-006AFE go-down-times">
            <div
              v-for="(item, index) in configs"
              :key="index"
              class="inline-block"
            >
              <span
                @click="timeValue = item.value"
                class="inline-block font-28 c-006AFE p-0-12 go-down-times-inner"
                :class="{
                  on: timeValue === item.value
                }"
              >
                {{ item.name }}
              </span>
              <span
                v-if="
                  index !== configs.length - 1 &&
                  timeValue !== item.value &&
                  timeValue !== item.value + 1
                "
                class="inline-block h-8 w-1 bl-006AFE"
              ></span
            ></div>
          </div>
        </div>
        <div
          class="fb fb-main-between fb-cross-center h-56 font-34"
          v-if="timeValue === 1"
        >
          <label for="" class="c-171A1D">同步上课日期</label>
          <div class="c-171A1D-40" @click="methodSelectedMonth">
            <span>{{ targetDimDay || '请选择日期' }}</span>
            <i class="iconfont">&#xe68d;</i>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-FFFFFF p-8-0 p-0-16 fb fb-main-between">
      <md-button @click="confirm">保存</md-button>
      <md-button
        @click="deleteRestDay"
        type="submary"
        class="ml-10"
        v-if="isEdit"
        >清除</md-button
      >
    </div>
  </div>
</template>

<script>
import { mcDatePicker } from '@/utils/mcSdkUtils'
import { dateToTime, timeFormat } from '@/utils/comUtils'
import API from '@/api'
import mixin from '@/mixin'

export default {
  name: 'PageSchoolCalendarEdit',
  mixins: [mixin],
  data() {
    return {
      timeValue: 1,
      configs: [
        {
          name: '上课',
          value: 1
        },
        {
          name: '休息',
          value: 2
        }
      ],
      targetDimDay: timeFormat(new Date(), 'YYYY-MM-DD'),
      sourceDimDay: {},
      isEdit: false
    }
  },
  mounted() {
    let { restDay, targetDimDay, sourceDimDay, workDay } = this.$route.query
    this.timeValue = restDay ? 2 : 1

    this.targetDimDay = dateToTime(targetDimDay, '-')
    const formatTime = new Date(dateToTime(sourceDimDay, '-'))
    this.sourceDimDay = {
      year: timeFormat(formatTime, 'YYYY'),
      month: timeFormat(formatTime, 'MM'),
      day: timeFormat(formatTime, 'DD')
    }
    this.isEdit = !!restDay || !!workDay
  },
  methods: {
    // 取消校历设置
    schoolCalendarCancel() {
      return new Promise((resolve, reject) => {
        API.schoolCalendarCancel({
          orgId: this.orgId,
          operUserDingId: this.dingUserId,
          operUserName: this.dingUserName,
          ...this.sourceDimDay,
          ...this.commonParams
        })
          .then(res => {
            if (res && res.result && +res.result !== 0) {
              this.$Toast({
                content: res.message
              }).show()
              reject(res)
            } else {
              this.$Toast({
                content: '操作成功'
              }).show()
              setTimeout(() => {
                this.$router.go(-1)
              }, 1500)
              resolve(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    deleteRestDay() {
      let that = this
      this.$Dialog({
        type: 'confirm',
        title: '清除节假日设置',
        content: `清除后，将恢复当天的上课规则，确认清除？`,
        onConfirm() {
          that.schoolCalendarCancel()
        }
      }).show()
    },
    // 选择月份
    methodSelectedMonth() {
      mcDatePicker({
        date: this.dimDay,
        maxDate: new Date(
          new Date(dateToTime(this.$route.query.schoolTermEndDimDay, '/'))
        ),
        format: 'YYYY-MM-DD'
      })
        .then(({ date } = {}) => {
          this.targetDimDay = date
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 某一天设置校历的休息日
    confirmChangeDay(type, params) {
      return new Promise((resolve, reject) => {
        API[type]({
          orgId: this.orgId,
          operUserDingId: this.dingUserId,
          operUserName: this.dingUserName,
          ...this.sourceDimDay,
          ...this.commonParams,
          ...params
        })
          .then(res => {
            if (res && res.result && +res.result !== 0) {
              this.$Toast({
                content: res.message
              }).show()
              reject(res)
            } else {
              this.$Toast({
                content: '操作成功'
              }).show()

              resolve(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async confirm() {
      if (!this.targetDimDay && this.timeValue === 1) {
        this.$Toast({
          content: '请选择同步上课日期！'
        }).show()
        return
      }
      let params = {}
      if (this.timeValue === 1) {
        let targetTime = new Date(this.targetDimDay.replace(/-/g, '/'))
        params = {
          targetYear: timeFormat(targetTime, 'YYYY'),
          targetMonth: timeFormat(targetTime, 'MM'),
          targetDay: timeFormat(targetTime, 'DD')
        }
      }
      try {
        await this.confirmChangeDay(
          this.timeValue === 1
            ? 'schoolCalendarWorkDay'
            : 'schoolCalendarRestDay',
          params
        )
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.go-down-times {
  height: 28px;
  border-radius: 99999px;
  padding: 0;
  overflow: hidden;
}
.bl-006AFE {
  border-left: 1px solid #006afe;
}

[data-dpr='2'] .bl-006AFE {
  border-left: 2px solid #006afe;
}

[data-dpr='3'] .bl-006AFE {
  border-left: 3px solid #006afe;
}
.go-down-times-inner {
  height: 26px;
  line-height: 26px;
  &.on {
    background: #006afe;
    color: #fff;
    border-radius: 99999px;
  }
}
</style>
